import styled from 'styled-components';

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const CurrentPrice = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.secondary.dark};
`;

export const OriginalPrice = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
  text-decoration: line-through;
`;

export const DiscountBadge = styled.span`
  background: ${({ theme }) => theme.colors.accent.main};
  color: ${({ theme }) => theme.colors.primary.dark};
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  padding: 2px 6px;
  border-radius: ${({ theme }) => theme.metrics.radius.small};
  font-weight: 600;
`;
